var render = function (_h,_vm) {var _c=_vm._c;return _c('svg',{staticClass:"svg-icon",class:_vm.props.className,attrs:{"aria-hidden":"true"}},[_c('use',{attrs:{"xlink:href":("#" + (_vm.props.name))}})])}
var staticRenderFns = []

export { render, staticRenderFns }